<!--
@Time : 2020/11/26 7:56 下午
@Author : yekong
@File : chenben.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="cbkz">
      <div class="sh">
        {{list[0].title}}：{{list[0].fenshu}}{{list[0].danwei}}
      </div>
      <div class="bj">
        {{list[1].title}}：{{list[1].fenshu}}{{list[0].danwei}}
      </div>
      <div class="dl">
        {{list[2].title}}：{{list[2].fenshu}}{{list[0].danwei}}
      </div>
      <div class="sz">
        {{list[3].title}}：{{list[3].fenshu}}{{list[0].danwei}}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "chenben",
  data: function () {
    return {}
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.cbkz {
  width: 452px;
  height: 345px;
  margin-top: 36px;
  position: relative;
  background: url("../assets/chengbenkongzhi.png") center center no-repeat;

  .sh {
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #6B4397;
    height: 50px;
    padding-right: 30px;
    background: url("../assets/shanghaibg.png") bottom right no-repeat;
    position: absolute;
    left: 40px;
    top: 100px;
  }

  .bj {
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #63C4E0;
    height: 150px;
    padding-left: 20px;
    background: url("../assets/beijingbg.png") 0px 30px no-repeat;
    position: absolute;
    left: 270px;
    top: 100px;
  }

  .dl {
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(218, 111, 68, 1);
    height: 50px;
    padding-right: 30px;
    background: url("../assets/dalianbg.png") bottom right no-repeat;
    position: absolute;
    left: 50px;
    top: 160px;
  }

  .sz {
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(104, 188, 117, 1);
    height: 150px;
    padding-left: 20px;
    background: url("../assets/shenzhenbg.png") 0px 30px no-repeat;
    position: absolute;
    left: 280px;
    top: 180px;
  }
}

</style>
